module.exports = __webpack_public_path__ + "img/cc-logo.e3b34a44.png";